import React, { ReactNode } from 'react';
import { SnackbarProvider } from 'notistack';
import { ThemeProvider, StylesProvider, makeStyles } from '@material-ui/core/styles';
import MomentUtils from '@date-io/moment';
import { MuiPickersUtilsProvider, } from '@material-ui/pickers';
import { SwitchableLocalizationProvider } from './toolympus/components/localization/LocalizationProvider';
import { FormatsProvider } from './toolympus/components/schemed';

import { theme } from './theme';
import { RACAMessages } from './messages';

const useNotistackStyles = makeStyles({
    // Define your custom error color
    variantError: {
        backgroundColor: '#932A2E !important',
        color: '#ffffff !important', // Ensure text is visible
    },
    // You can also do this for success, warning, info
    variantSuccess: {
        backgroundColor: '#279dd5 !important', 
    }
});

interface Props {
    children?: ReactNode;
}

export const Providers = (props: Props) => {
    const notistackClasses = useNotistackStyles();
    return (
        <ThemeProvider theme={theme}>
            <StylesProvider injectFirst>
                <SwitchableLocalizationProvider defaultLocale='ru' customMessagesMultiLocale messages={RACAMessages} localStorageKey="__racap_lang">
                    <FormatsProvider formats={{ date: "D MMMM YYYY", shortDatetime: "D MMMM HH:mm", thousandSeparator: " " }}>
                        <SnackbarProvider maxSnack={3} anchorOrigin={{ horizontal: 'center', vertical: 'top' }} classes={notistackClasses}>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                                {props.children}
                            </MuiPickersUtilsProvider>
                        </SnackbarProvider>
                    </FormatsProvider>
                </SwitchableLocalizationProvider>
            </StylesProvider>
        </ThemeProvider>
    );
}
